import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getCipCodeOptions,
  getCourseCodeById,
  getCourseCodeFormViewModel,
  getCourseCodeListItems,
} from '../../services/courseCode.service';
import { CipCodeModel } from '../../types/CipCodeModel';
import { CourseCodeFormViewModel } from '../../types/CourseCodeFormViewModel';
import { CourseCodeListItemModel } from '../../types/CourseCodeListItemModel';
import { CourseCodeModel } from '../../types/CourseCodeModel';
import { SelectOption } from '../../types/SelectOption';

export const fetchCourseCodeListItems = createAsyncThunk(
  'input/fetchCourseCodeListItems',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      CourseCodeListItemModel[]
    >(thunkAPI, getCourseCodeListItems({ signal: thunkAPI.signal }));
  }
);

export const fetchCourseCodeById = createAsyncThunk(
  'input/fetchCourseCodeById',
  async (courseCodeId: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<CourseCodeModel>(
      thunkAPI,
      getCourseCodeById(courseCodeId, { signal: thunkAPI.signal })
    );
  }
);

export const fetchCourseCodeFormViewModel = createAsyncThunk(
  'input/fetchCourseCodeFormViewModel',
  async (_, thunkAPI) => {
    const formViewModel =
      await thunkExecuteAndReturnResultOrShowError<CourseCodeFormViewModel>(
        thunkAPI,
        getCourseCodeFormViewModel({ signal: thunkAPI.signal })
      );

    const cipCodeOptions = await thunkExecuteAndReturnResultOrShowError<
      CipCodeModel[]
    >(thunkAPI, getCipCodeOptions({ signal: thunkAPI.signal }));

    const mappedCipCodeOptions: SelectOption[] =
      cipCodeOptions?.map((cipCode) => ({
        value: cipCode.cipCode,
        text: `${cipCode.cipCode} ${cipCode.cipTitle}`.trim(),
      })) ?? [];

    return {
      ...formViewModel,
      cipCodeOptions:
        mappedCipCodeOptions.length > 0
          ? mappedCipCodeOptions
          : formViewModel?.cipCodeOptions ?? [],
    };
  }
);
